export default __webpack_public_path__ + "static/media/three-fracuccions.6d0e56bf.webp";